<template>
  <Transition name="modal">
    <div v-if="showModal" class="modal-mask" id="modalLegalWarning">
      <div class="modal-container">
        <div class="bella-modal" id="legal-warning">
          <div class="div-aviso18">
            <div class="title">
              <div>
                <span class="title-text">
                  {{ translate.legalWarningTitle }}
                </span>
                <span class="title-age">
                  {{ translate.legalWarningAge }}
                </span>
              </div>
            </div>
            <div class="txt" v-html="translate.legalWarningText"></div>
            <a href="#" rel="nofollow" class="sim" @click.prevent="modalHide()">
              {{ translate.legalWarningButton }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue'
  import { localeStore } from '../../stores/locale'
  import legalTradutor from '../../tradutors/legalwarning'
  import { useCookies } from 'vue3-cookies'
  const { cookies } = useCookies()
  const showModal = ref(false)
const route = useRoute()

  const translate = computed(() => {
    return route.params.language === 'pt-br' ? legalTradutor.portugues : legalTradutor.ingles
  })

  function modalHide() {
    showModal.value = false
    var daysAccess = 1000 * 60 * 60 * 24 * 7 // 7 dias
    cookies.set('legalWarning', '1', daysAccess)
    // As tools do WebMCP só são registradas depois do aceite 18+ (site adulto).
    // Sem este aviso, quem estivesse na primeira visita só ganharia as tools no
    // próximo carregamento — ou precisaríamos ficar em polling no cookie.
    window.dispatchEvent(new CustomEvent(LEGAL_WARNING_ACCEPTED_EVENT))
  }

  onMounted(() => {
    if (!cookies.isKey('legalWarning')) {
      showModal.value = true
    }
  })
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
  }

  .modal-container {
    width: 780px;
    margin: auto;
    padding: 0px 0px;
    background-color: #fff;
    border-radius: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }

  .div-aviso18 {
    z-index: 450;
    width: 780px;
    height: auto;
    padding-top: 30px;
    padding-bottom: 35px;
    background-position: center 30px;
    background-repeat: no-repeat;
    background-color: #fff;
    border: 1px solid #bbb;
    text-align: center;
  }

  .div-aviso18 div.txt {
    width: 84%;
    font-size: 16px;
    text-align: justify;
    margin: 45px auto 30px;
    color: #000;
  }

  .div-aviso18 a {
    vertical-align: top;
    text-decoration: none;
    color: #fff;
    text-transform: uppercase;
    cursor: pointer;
    display: inline-block;
    margin: 0 8px;
  }

  .div-aviso18 a.sim {
    padding: 0 25px;
    height: 50px;
    line-height: 48px;
    font-size: 22px;
    font-weight: 700;
    border-radius: 6px;
    background-color: #b20000;
  }

  .title-text {
    font-size: 3.5em;
    margin: 0 auto;
    font-weight: 100;
    padding: 7px;
  }

  .title-age {
    font-size: 3.5em;
    color: white;
    border-radius: 0 5px 0 0;
    background-color: #b20000;
    font-weight: bold;
    padding: 7px;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 969px) {
    .modal-container {
      width: 95%;
    }
    .div-aviso18 {
      width: 100%;
      padding-top: 15px;
      padding-bottom: 15px;
    }

    .div-aviso18 div.txt {
      width: 90%;
      font-size: 11px;
      margin: 20px auto 30px;
    }

    .title-text,
    .title-age {
      font-size: 1.5em;
    }
    .div-aviso18 a.sim {
      font-size: 16px;
    }
  }
</style>
